import client from './client';
import type { ProductionMethod } from '@/types/api';

export const productionMethodsApi = {
  getAll: async (includeInactive = false): Promise<ProductionMethod[]> => {
    const response = await client.get<ProductionMethod[]>('/production-methods', {
      params: { includeInactive },
    });
    return response.data;
  },

  getById: async (id: string): Promise<ProductionMethod> => {
    const response = await client.get<ProductionMethod>(`/production-methods/${id}`);
    return response.data;
  },

  create: async (data: Partial<ProductionMethod>): Promise<ProductionMethod> => {
    const response = await client.post<ProductionMethod>('/production-methods', data);
    return response.data;
  },

  update: async (id: string, data: Partial<ProductionMethod>): Promise<ProductionMethod> => {
    const response = await client.put<ProductionMethod>(`/production-methods/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/production-methods/${id}`);
  },

  seedDefaults: async (): Promise<void> => {
    await client.post('/production-methods/seed');
  },
};
